require('./sctProfileCard.scss');

const sctProfileCard = angular.module('app.sct.sctProfileCard', []);

sctProfileCard.component('sctProfileCard', {
  bindings: {
    profile: '=',
    onCancel: '&',
    onSendInvite: '&'
  },
  controller: ['$state', 'SCT_CONFIG', sctProfileCardCtrl],
  controllerAs: 'vm',
  template: require('./sctProfileCard.html')
});

function sctProfileCardCtrl($state, SCT_CONFIG) {
  let vm = this;

  vm.isCancelling = false;
  vm.roles = SCT_CONFIG.roles;
  vm.view = view;
  vm.doCancel = doCancel;

  function view(id) {
    $state.go('app.admin.people.view', { id });
  }

  function doCancel(profile) {
    vm.isCancelling = true;
    vm.onCancel(profile);
  }
}

export default sctProfileCard;



// WEBPACK FOOTER //
// ./src/components/sct/sctProfileCard/sctProfileCard.js